/** @type {import('tailwindcss').Config} */
const defaultTheme = require('tailwindcss/defaultTheme')

module.exports = {
  content: [
    './src/pages/**/*.{js,jsx,ts,tsx}',
    './src/components/**/*.{js,jsx,ts,tsx}'
  ],
  theme: {
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.75rem',
      '4xl': '1.875rem',
      '5xl': '2.375rem',
      '6xl': '3rem',
      '7xl': '3.125rem',
      '8xl': '6.875rem'
    },
    extend: {
      screens: {
        xs: '376px'
      },
      colors: {
        'brand-primary': '#01DD93',
        'brand-secondary': '#F3F3F3',
        'line-grey': '#CCCCCC'
      },
      fontFamily: {
        sans: ['Space Grotesk', ...defaultTheme.fontFamily.sans]
      },
      animation: {
        'scroll-logos': 'scroll linear infinite 10s'
      },
      keyframes: {
        scroll: {
          '0%': { transform: 'translateX(0)' },
          '100%': { transform: 'translateX(calc(0px - 100% - 1rem))' }
        }
      },
      borderWidth: {
        1: '1.5px'
      }
    }
  }
}
